import { ProtectedRouteOption } from '@/shared/components/Auth/ProtectedRoute.consts';
import { AdminDocs } from './AdminDocs/AdminDocs';
import { AdminsSection } from './AdminsPanel/Admins';
import { VendorsSection } from './VendorsPanel/Vendors';
import { PAGES } from '@/shared/consts';
import { DocumentationPage } from '../Docs/DocumentationPage/DocumentationPage';
import { ConfigurationPage } from '../Docs/ConfigurationPage/ConfigurationPage';
import { AdminNotFound } from '@/shared/pages/NotFound/AdminNotFound';
import { VersionsControl } from './VersionsControl/VersionsControl';
import { LeadsSection } from './LeadsPanel/Leads';
import { TrustedSources } from './TrustedSources/TrustedSources';
import { EnterprisesSection } from './EnterprisesPanel/Enterprises';
import { AdminPermissions } from '@user1st/api-client';
import { A11yScannerSection } from './A11yScanner/A11yScaner';

export const adminRoutes: ProtectedRouteOption[] = [
  {
    path: PAGES.AFTER_LOGIN.ADMIN_DOCS,
    element: <AdminDocs />,
    permission: AdminPermissions.ReadFramework,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMINS,
    element: <AdminsSection />,
    permission: AdminPermissions.ReadAdmin,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_BDR,
    element: <LeadsSection />,
    permission: AdminPermissions.ReadLead,
  },
  {
    path: PAGES.AFTER_LOGIN.VENDORS,
    element: <VendorsSection />,
    permission: AdminPermissions.ReadVendor,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_DOCUMENTATION,
    element: <DocumentationPage />,
    permission: AdminPermissions.ReadFramework,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_CONFIGURATION,
    element: <ConfigurationPage />,
    permission: AdminPermissions.ReadFramework,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_VERSIONS,
    element: <VersionsControl />,
    permission: AdminPermissions.ReadPackageVersion,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_TRUSTED_SOURCES,
    element: <TrustedSources />,
    permission: AdminPermissions.ReadTrustedSource,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_ENTERPRISES,
    element: <EnterprisesSection />,
    permission: AdminPermissions.ReadEnterprise,
  },
  {
    path: PAGES.AFTER_LOGIN.ADMIN_A11Y_SCANNER,
    element: <A11yScannerSection />,
    permission: AdminPermissions.FreeToolA11YScanner,
  },
  {
    path: PAGES.SHARED.NOT_FOUND,
    element: <AdminNotFound $homePath={PAGES.SHARED.DEFAULT} />,
  },
];
